import stationDataConfigApi from '@/api/config/stationDataConfig'
import type { STATION_DETAIL } from '@/types/station'

const hasName = (value: unknown) =>
  typeof value === 'string' && value.trim() !== ''

const fetchStoredStationName = async (
  interfaceId: string,
  stationId: string,
): Promise<string | undefined> => {
  try {
    const { data }: any = await stationDataConfigApi.getAll({
      interfaceId: Number(interfaceId),
      StationIds: [Number(stationId)],
      PageIndex: 1,
      PageSize: 1,
    })
    const row = (data?.data ?? []).find(
      (station: any) => Number(station?.id) === Number(stationId),
    )
    return hasName(row?.description) ? row.description : undefined
  } catch (error) {
    console.error('Failed to read the station name from the station list:', error)
    return undefined
  }
}

// DECISION: the station name is read from the station list when the detail response has none, not left to fall back to the decoder name, because GET /api/station/{interfaceId}/{id} carries no Description and every form built from it renamed the station to its decoder (SCRUM-1157).
export const fetchStationDetail = async (
  interfaceId: string,
  stationId: string,
): Promise<STATION_DETAIL | null> => {
  const { data } = await stationDataConfigApi.getById(interfaceId, stationId)
  if (!data) return null
  if (hasName(data.description)) return data

  const description = await fetchStoredStationName(interfaceId, stationId)
  return description ? { ...data, description } : data
}
